import { getConfiguredCache } from 'money-clip';
import applicationSettings from '../../../Core/Settings/ApplicationSettings';

class CacheService {
    private internalCache: any;

    private enabled = true;

    constructor() {
        this.internalCache = getConfiguredCache({
            version: applicationSettings.applicationVersion,
            maxAge: applicationSettings.isDevelopmentLike ? 30000 : 3600000,
            name: applicationSettings.applicationName,
        });
    }

    isEnabled = (): boolean => this.enabled;

    enable = (): void => {
        this.enabled = true;
    };

    disable = (): void => {
        this.enabled = false;
    };

    set = async <T>(key: string, value: T): Promise<void> => {
        this.internalCache.set(key, value, { version: applicationSettings.applicationVersion });
    };

    get = async <T>(key: string): Promise<T | undefined> => {
        if (!this.enabled) {
            return undefined;
        }

        return this.internalCache.get(key, { version: applicationSettings.applicationVersion }) as Promise<T | undefined>;
    };

    delete = async (key: string): Promise<void> => {
        this.internalCache.del(key, { version: applicationSettings.applicationVersion }) as Promise<void>;
    };
}

const cacheService = new CacheService();
export default cacheService;
